// React
import React, { useCallback, useEffect, useState } from 'react';
import {
  Col,
  Row,
  Modal,
  Input,
  Label,
  Button,
  CardFooter,
  ModalHeader,
} from 'reactstrap';

// Components
import { Currency } from '../../../../components/currencyInput';
import { SelectInput } from '../../../../components/selectInputComponent';

// Helpers
import { APIClient } from '../../../../helpers/api_helper';

export const ModalEditValueOfPlan = ({
  isOpen,
  toggle,
  handleSubmit,
  categoryPlanSelected,
  planSelected,
  selectedRows,
}) => {
  const [value, setValue] = useState(null);
  const [isAllow, setIsAllow] = useState(false);
  const [plansData, setPlansData] = useState([]);
  const [plan, setPlan] = useState();
  const [calculation, setCalculation] = useState(null);
  const [effectiveDate, setEffectiveDate] = useState(null);

  const api = new APIClient();

  const getPlanByCategoryID = useCallback(() => {
    api
      .get(`/register/plan-by-category/${categoryPlanSelected?.value}`)
      .then((res) => {
        setPlansData(res.data);
      });
  }, [categoryPlanSelected, planSelected]);

  useEffect(() => {
    if (categoryPlanSelected) {
      getPlanByCategoryID();
    }
  }, [categoryPlanSelected, planSelected]);

  return (
    <Modal
      id="fadeInleftModal"
      isOpen={isOpen}
      toggle={() => {
        toggle();
      }}
      onClosed={() => {
        setIsAllow(false);
      }}
      modalClassName="fadeInLeft"
      size="lg"
      unmountOnClose
      centered
      autoFocus={false}
    >
      <ModalHeader>Atualizar Valor de Plano</ModalHeader>
      <form
        autoComplete="off"
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit(
            value,
            plan.value,
            calculation,
            effectiveDate,
            selectedRows
          );
        }}
      >
        <div className="modal-body">
          <Row className="mb-2">
            <Col xs={6} md={6} lg={6}>
              <Label for="saleAtInput" className="form-label">
                Novo Plano
              </Label>
              <SelectInput
                options={plansData}
                value={plan}
                placeholder="Pesquisar por plano"
                className={isAllow ? 'form-control' : 'form-control  bg-light'}
                inputId="plan"
                isDisabled={!isAllow}
                onChange={(eventInput) => {
                  setPlan(eventInput);
                }}
              />
            </Col>

            <Col xs={6} md={3} lg={3}>
              <Label htmlFor="type-name" className="form-label">
                Novo Valor
              </Label>
              <Currency
                id="newValue"
                value={value}
                disabled={!isAllow}
                onChange={(_, withoutMask) => {
                  setValue(withoutMask);
                }}
              />
            </Col>

            <Col xs={6} md={3} lg={3}>
              <Label htmlFor="type-name" className="form-label">
                Base de Cálc. Comiss
              </Label>
              <Currency
                id="commission_calc_base"
                value={calculation}
                disabled={!isAllow}
                onChange={(_, withoutMask) => {
                  setCalculation(withoutMask);
                }}
              />
            </Col>

            <Col xs={6} md={3} lg={3} className="mt-2">
              <Label htmlFor="effectiveDate" className="form-label">
                Nova Vigência
              </Label>
              <Input
                className="form-control"
                type="date"
                id="effectiveDate"
                disabled={!isAllow}
                value={effectiveDate}
                onChange={(e) => {
                  setEffectiveDate(e.target.value);
                }}
              />
            </Col>
          </Row>

          <Col className="mb-3">
            <span id="checkbox-wrapper">
              <Input
                className="form-check-input me-2"
                type="checkbox"
                id="funeralAssistance"
                onChange={(e) => {
                  setIsAllow(e.target.checked);
                }}
                checked={isAllow}
              />
              <Label for="funeralAssistance">
                Estou ciente dos riscos e quero continuar com a alteração de
                valores
              </Label>
            </span>
          </Col>
        </div>

        <CardFooter>
          <div className="modal-footer p-0">
            <button
              className="btn btn-link"
              onClick={() => {
                toggle();
              }}
              type="button"
            >
              {' '}
              Cancelar{' '}
            </button>
            <Button color="primary" type="submit" disabled={!isAllow}>
              {' '}
              Processar{' '}
            </Button>
          </div>
        </CardFooter>
      </form>
    </Modal>
  );
};
